export enum ErrorLogin {
  ERROR_REFRESH_TOKEN_TIME_OUT = 'ERROR_REFRESH_TOKEN_TIME_OUT'
}
